<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/nxlb/nxlb.jpg" class="steps step1" v-if="status==1">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <breadcrumb :routerList="[{to:'/yuce/domesticList_screening',title:'国内市场'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-formBox w-formBox">
							<el-form-item label="选择月">
								<el-date-picker
										:clearable="false"
										v-model="formInline.month"
										type="month"
										value-format="yyyy-MM"
										placeholder="--月份--">
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
							</el-form-item>
						</div>
                    </el-form>
            </div>
            <div class="h-row yuCe">
                <div class="h-rowIn nxlbzb" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange"
                            :data="tableData"
                            stripe
							border
							max-height="560"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="45">
                        </el-table-column>
                        <el-table-column
                                fixed
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="month"
                                label="预测月份"
                                width="90"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                label="产品型号"
                                width="160"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.proModel}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                label="产品编码"
                                width="110"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="planNum"
                                label="预测总数"
                                width="90"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.planNum}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="snyj"
                                label="上年月均"
                                width="90"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.snyj}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="qnyj"
                                label="前年月均"
                                width="90"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.qnyj}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="q4yj"
                                label="上年度Q4月均"
                                width="130"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.q4yj}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="ljyj"
                                label="当年累计月均"
                                width="120"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.ljyj}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="syxl"
                                label="当年上月销量"
                                width="120"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.syxl}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="ydtq"
                                label="上年度月度同期"
                                width="140"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.ydtq}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="jzkc"
                                label="上月结帐库存"
                                width="120"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.jzkc}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="singleStruggle"
                                label="散单纠偏"
                                width="120"
                                class-name="h-tableInputTd"
                                label-class-name="h-tableEditIcon">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.singleStruggle"
                                        placeholder="0"
                                        class="h-tableInput"
                                        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                        onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="engiProject"
                                label="工程项目"
                                width="120"
                                class-name="h-tableInputTd"
                                label-class-name="h-tableEditIcon">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.engiProject"
                                        placeholder="0"
                                        class="h-tableInput"
                                        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                        onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resAssessment"
                                label="货源预估"
                                width="120"
                                class-name="h-tableInputTd"
                                label-class-name="h-tableEditIcon">
                            <template slot-scope="scope">
                                <el-input
                                        v-model="scope.row.resAssessment"
                                        placeholder="0"
                                        class="h-tableInput"
                                        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                        onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="wf"
                                label="未发"
                                width="60"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: right;">
								        {{scope.row.wf}}
								    </div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="ws"
                                label="未审"
                                width="60"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.ws}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column label="已排产未下线">
                            <el-table-column
                                    prop="num"
                                    :show-overflow-tooltip="true"
									width="60"
                                    label="数量">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.num}}
									    </div>
									</template>
                            </el-table-column>
                            <el-table-column
                                    prop="time"
                                    :show-overflow-tooltip="true"
									width="100"
                                    label="时间">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="80">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="chakan(scope.row.month,scope.row.proCode)">
                                    查看
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30 company">
                <div class="h-tableBL">
                    <el-button
                            class="h-btn h-formBtn h-bgblueQ"
                            icon="h-el-icon h-el-icon-import"
                            style="margin-left:-20px;"
                            @click="exportExcel"
                    >
                        批量导出
                    </el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="handleFilter"/>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <!-- <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button> -->
                <el-button v-if="showSave" class="h-btn h-bBtn h-bggreen" @click="saveTo">保存</el-button>
            </div>
        </div>

    </div>
</template>
<style scoped>
    .company {
        margin-left: 20px;
    }

</style>
<style>
    .yuCe .el-table thead.is-group th {
        background-color: #57aefe;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
		z-index: 999999;
    }

    .newtext{
    	font-size: 0.28rem;
    	color: white;
    	position: absolute;
    	top:0.2rem;
    	left: 50%;
    	transform: translateX(-50%);
    	font-weight: bold;
    	text-shadow:1px 1px 4px #2785E7;
    	z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
    }

    .leaderbg {
        width: 100%;
        height: 100%;
    }

    .steps {
        position: absolute;
        z-index: 1;

    }

    .step1 {
       top: 0;
       left: 0;
    }

    .stepbtn {
        width: 1.9rem;
        height: 0.6rem;
        border: 0.03rem solid #FFFFFF;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        line-height: 0.5rem;
        position: absolute;
        z-index: 99;
        bottom: 0.75rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.27rem;
        letter-spacing: 2px;
        color: white;
        cursor: pointer;
    }

    .closeIt {
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        cursor: pointer;
		z-index: 2;
    }
</style>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import marketList from '../../../assets/images/marketList.png'
    import marketNew from '../../../assets/images/market-new.png'
    import maskClose from '../../../assets/images/maskClose.png'

    export default {
        data() {
            return {
				showOrhide:false,
                toshow:'domesticList1',
                checked: true,
                status: 1,
                imgObi: {marketList, marketNew, maskClose},
                dialogFormVisible2: false,
                showSave: true,
                opt: '',
                mon: '',
                formInline: {
                    month: this.getyyyyMMdd(),
                    idlist: [],
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                multipleSelection: [],
                tableData: [],
            }
        },
        mounted() {

        },
        created() {
			this.showzhezhao()
            this.showLevName();
            this.query();
        },
        activated(){
            this.handleFilter();
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                   ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                   	console.log(rd)
                   	this.showOrhide = false;
                   })
                }else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i) {
                console.log(i)
                if (this.status == 1) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        	console.log(rd)
                        	this.showOrhide = false;
                        })
                    }else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
                    
                }
            },
            //明细导出
            exportExcel() {
                // var idlist = [];
                // this.multipleSelection.forEach(element => {
                //     idlist.push(element.id);
                // });
                this.formInline.idlist = [];
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(element => {
                        this.formInline.idlist.push(element.id);
                    });
                }
                updownfile.down("/api/swyl/v1/demo/bscForecastDetailCore/downloadExcel", this.formInline, "post", 'data');
            },
            // 重置按钮
            resetData() {
                this.formInline.month = this.getyyyyMMdd();
                this.formInline.pageSize = 10;
                this.query();
            },
            getyyyyMMdd() {
                const now = new Date()
                return [now.getFullYear(),
                    now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1,].join('-');
            },
            chakan(month, proCode) {
                this.$router.push({
                    path: '/yuce/xiangqing',
                    query: {month: month, proCode: proCode}
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            selectPage() {
                ss.zongbu.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    this.mon = this.formInline.month;
                })
            },
            query() {
                ss.zongbu.showPage(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    if (this.tableData.length == 0) {
                        this.showSave = false;
                    }
                })
            },
            showLevName() {
                ss.zongbu.showLName().then(rd => {
                    this.opt = rd;
                })
            },
            handleFilter() {
                this.query();
            },
            saveTo() {
                ss.zongbu.saveTo(this.tableData).then(rd => {
                    this.tableData = rd.records;
                    this.$msg.msgs(rd.msg);
                    this.selectPage();
                })
            },
            renovate() {
                this.resetData();
                // window.location.href = '';
                // this.query();
                // this.$router.go(-1);
            }
        }
    }
</script>
<style>
	.nxlbzb .h-tableInput .el-input__inner{	
		padding: 0.05rem 0.1rem;
	}
	.nxlbzb .el-table tbody td .cell{
		padding: 0.05rem 0.1rem;
	}
</style>